import { getEnumValues } from './get-enum-values';
/**
 * Supported Stripe Currencies: https://stripe.com/docs/currencies
 */
export enum Currency{
	USD="usd",
	CAD="cad",
}
export const CurrencyValues = getEnumValues<Currency>(Currency);